import HyperDiv from "components/ProjectNonSpecificComponents/Elements/HyperDiv/HyperDiv"
import Whitespace from "components/ProjectNonSpecificComponents/Elements/Whitespace"
import getUrl from "components/ProjectNonSpecificComponents/Functions/getUrl"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { url } from "inspector"
import React from "react"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router"
import PreferencesNavBarTabSelectionButton from "./Buttons/PreferencesNavBarTabSelectionButton"

const ConfigSectionButtons = () => {
	const history = useHistory()
	const location = useLocation()
	const { t } = useTranslation()
	return (
		<HyperDiv direction="row" centeredX alignedTop>
			<PreferencesNavBarTabSelectionButton
				selected={location.pathname.includes(ROUTES.REQUEST_CNFG)}
				onClick={() => history.push(ROUTES.REQUEST_CNFG)}
				children={t("button.requestConfig")}
			/>
			<Whitespace x="0.5" h />
			<PreferencesNavBarTabSelectionButton
				selected={
					location.pathname.includes(ROUTES.PTKM) &&
					!location.pathname.includes(ROUTES.PTKM_CALENDAR)
				}
				onClick={() => history.push(ROUTES.PTKM)}
				children={t("button.PTKMConfig")}
			/>
			<Whitespace x="0.5" h />
			<PreferencesNavBarTabSelectionButton
				selected={location.pathname.includes(ROUTES.PTKM_CALENDAR)}
				onClick={() => history.push(ROUTES.PTKM_CALENDAR)}
				children={t("button.calendar")}
			/>
		</HyperDiv>
	)
}

export default ConfigSectionButtons
